<template>
	<ProgressSpinner v-if="!device"/>
	<Container class="pt-6" v-if="device">
		<div class="bg-surface-0 dark:bg-surface-900 -mx-8 px-8 -mt-6 pt-6 -mb-4 pb-4">
			<PageHeading>
				{{ device.serial_number ?? $route.params.device }}
				<span v-if="device.is_deleted" class="ml-2 px-2 py-1 text-xs bg-yellow-200 text-yellow-800 rounded align-middle">Deleted</span>
			</PageHeading>
		</div>

		<div class="sticky top-0 bg-surface-0 dark:bg-surface-800 z-40 -mx-8 -px-8">
			<TabLayout :tabs="tabs" sticky/>
		</div>

		<router-view
				@on-save="onSave"
				@on-delete="$emit('on-delete')"
				:device="device"
		></router-view>
	</Container>
</template>

<script>
import PageHeading from "@/Components/PageHeading.vue";
import TabLayout from "@/Layouts/TabLayout.vue";
import { mapStores } from "pinia";
import { useDevicesStore } from "@/stores/devices.js";
import Container from "@/Components/Container.vue";


export default {
	name: "DeviceAdminView",
	components: {Container, TabLayout, PageHeading},
	data() {
		return {
			device: undefined,
		}
	},
	emits: [
		'on-save',
		'on-delete',
	],
  methods: {
    onSave() {
      this.refreshDevice();
      this.$emit('on-save');
    },
    async refreshDevice() {
      this.device = await this.devicesStore.showDevice(this.$route.params.device, {
        include: [
          'endOfLineTestingDocuments',
        ],
      });
    }
  },
	watch: {
		'$route.params.device': {
			async handler(newValue, oldValue) {
				if(newValue){
					// Reset device immediately to avoid showing previous device's name
					this.device = undefined;
					if(this.$route.params.device === 'NEW'){
						this.device = {};
					} else {
						await this.refreshDevice();
					}
				} else {
					this.device = undefined;
				}
			},
			immediate: true,
		}
	},
	computed: {
		...mapStores(useDevicesStore),
		tabs() {
			return [
				{
					label: this.$t('pages.admin.devices.devices.device.device_admin_view.properties'),
					current: this.$route.name === 'admin.devices.device',
					to: {name: 'admin.devices.device', params: this.$route.params}
				},
				// {
				// 	label: this.$t('pages.admin.devices.devices.device.device_admin_view.assets'),
				// 	current: this.$route.name === 'admin.devices.device.assets',
				// 	to: {name: 'admin.devices.device.assets', params: this.$route.params}
				// },
        {
          label: this.$t('pages.admin.devices.devices.device.device_admin_view.eolt_documents'),
          current: this.$route.name === 'admin.devices.device.end-of-line-testing-documents',
          to: {name: 'admin.devices.device.end-of-line-testing-documents', params: this.$route.params},
          permission: 'read:end-of-line-testing-documents',
        },
        {
          label: this.$t('pages.admin.devices.devices.device.device_admin_view.history'),
          current: this.$route.name === 'admin.devices.device.history',
          to: {name: 'admin.devices.device.history', params: this.$route.params}
        },
			].filter(t => (t.permission === undefined || this.$auth.hasPermission(t.permission)) && !t.hide)
		}
	},
}
</script>
